import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    getLeads: {
        leads: {
            company: string,
            country: string,
            email: string,
            id: string,
            industry: string,
            name: string,
            phone: string,
            status: string,
        }[],
        totalCount: number
    }
}

interface Variables {
    limit: number,
    offset: number,
}

export const GET_LEADS: TypedDocumentNode<Result, Variables> = gql`
    query GetLeads($limit: Int, $offset: Int) {
        getLeads(limit: $limit, offset: $offset) {
            leads {
                company
                country
                email
                id
                industry
                name
                phone
                status
            }
            totalCount
        }
    }       
`
